import React from 'react';
import classes from "./Layout2.module.css";

const Layout2 = ({children}) => {
  return (
    <div className={classes.game_overlay}>
      <div className={classes.game_container}>
        <div className={classes.game}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Layout2